import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PermissionsDirective } from './permissions.directive';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: []
})
export class AuthorizationModule { }